import { gql } from "@apollo/client";

export const ADD_SELLER_PRODUCT_MUTATION = gql`
  mutation AddSellerProduct($input: AddSellerProductInput!) {
    addSellerProduct(input: $input) {
      success
      message
      productId
      processingCommission
      salesCommission
    }
  }
`;
